import SharedMessage from '../shared/Message';

import {
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/autoPersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

const AutoMessage = (props: MessageProps) => {
  const formActions = {
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedMessage
      {...props}
      formStateKey="autoPersonalForm"
      formActions={formActions}
    />
  );
};

export default AutoMessage;
